document.addEventListener("DOMContentLoaded", function () {
  $(function () {
    if ($(window).width() <= 1279) {
      var headH = $(".shopify-section-group-header-group").length ? $(".shopify-section-group-header-group").height() * 2 + 4 : 4;
    } else if ($(window).width() > 1279 && $(window).width() <= 1400) {
      var headH = $(".shopify-section-group-header-group").length ? $(".shopify-section-group-header-group").height() * 2  - 1 : 0;
    } else {
      var headH = $(".shopify-section-group-header-group").length ? $(".shopify-section-group-header-group").height() * 2  : 0;
    }
    var triggerId = $(".nav-container .nav-item.nav-trigger").length
      ? $(".nav-container .nav-item.nav-trigger").attr(`data-target`)
      : $(".nav-container .nav-item").eq(0).attr(`data-target`);
    var mbtriggerId = $(".nav-container .nav-item.mb-nav-trigger").length
      ? $(".nav-container .nav-item.mb-nav-trigger").attr(`data-target`)
      : $(".nav-container .nav-item").eq(0).attr(`data-target`);
    if (
      $(window).width() > 590 &&
      $(`.section[data-id="${triggerId}"]`).length
    ) {
      var triggerOffsetTop =
        $(`.section[data-id="${triggerId}"]`).offset().top - headH;
    } else if (
      $(window).width() <= 590 &&
      $(`.section[data-id="${mbtriggerId}"]`).length
    ) {
      var triggerOffsetTop =
        $(`.section[data-id="${mbtriggerId}"]`).offset().top - headH;
    }
    $(`.gift-guide-nav .pc-nav`).css({ top: "0px" });
    $(`.gift-guide-nav .open-btn`).css({ top: headH + 20 + "px" });
    $(`.gift-guide-nav .mb-nav`).css({ top: "0px" });

    /* Click to Scroll */
    $(document)
      .off(`click`, `.gift-guide-nav .nav-item`)
      .on(`click`, `.gift-guide-nav .nav-item`, function (e) {
        e.stopPropagation();
        let self = $(this);
        let id = self.attr("data-target");
        let element = document.querySelector(`.section[data-id="${id}"]`);
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headH + 10;
        $("html, body").animate({ scrollTop: offsetPosition + "px" }, 500);
        if ($(window).width() < 590) {
          setTimeout(() => {
            $(".mb-toggle-btn").click();
          }, 500);
        }
      });

    /* Open or Close Nav*/
    $(document)
      .off(`click`, `.gift-guide-nav .open-btn`)
      .on(`click`, `.gift-guide-nav .open-btn`, function (e) {
        if ($(window).width() > 590) {
          $(this).removeClass("active");
          $(`.pc-nav`).removeClass("close").addClass("show");
          window.scrollBy({ top: 1, left: 0, behavior: "smooth" });
        }
      });
    $(document)
      .off(`click`, `.gift-guide-nav .toggle-btn`)
      .on(`click`, `.gift-guide-nav .toggle-btn`, function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(window).width() > 590) {
          /* PC Open or Close Nav*/
          let self = $(this);
          let parentEl = self.parent(`.pc-nav`);
          let openEl = $(`.open-btn`);
          parentEl.removeClass("show").addClass("close");
          openEl.addClass("active");
          window.scrollBy({ top: 1, left: 0, behavior: "smooth" });
        } else {
          /* Mobile Open or Close Nav */
          let self = $(this);
          let parentEl = self.parents(`.mb-nav`);
          if (parentEl.hasClass(`active`)) {
            parentEl.removeClass("active");
          } else {
            parentEl.addClass("active");
          }
        }
      });
    $(".gift-guide-nav .toggle-btn").keydown(function (e) {
      if (e.key == "Enter") {
        $(this).click();
      }
    });

    /* Scroll */
    var curr = 0;
    $(window).scroll(function (e) {
      curr = $(this).scrollTop();
      if (curr >= triggerOffsetTop && !$(`.nav-container`).hasClass("close")) {
        $(`.nav-container`).addClass(`show`);
        $(`.shopify-section-group-header-group`).css({
          opacity: "0",
          "z-index": "-1",
          transition: "all 0.15s linear",
        });
      } else {
        $(`.nav-container`).removeClass(`show`);
        $(`.shopify-section-group-header-group`).css({
          opacity: "1",
          "z-index": "3",
          transition: "all 0.15s linear",
        });
      }
      /* change current nav text */
      $(`.section`).each(function () {
        var scrollTop = $(window).scrollTop();
        var tempDivOffsetTop = $(this).offset().top - headH;
        var tempDivId = $(this).attr(`data-id`);
        if (scrollTop >= tempDivOffsetTop) {
          $(`.gift-guide-nav .pc-nav .nav-item[data-target="${tempDivId}"]`)
            .addClass("active")
            .siblings()
            .removeClass("active");
          let currNav = $(
            `.gift-guide-nav .mb-nav .nav-item[data-target="${tempDivId}"]`
          ).text();
          if (currNav) {
            $(`.gift-guide-nav .nav-container .curr-text`).text(currNav);
          }
        }
      });
    });
  });
});
